(function () {
    'use strict';
    const availableLoader = document.currentScript;

    if (!availableLoader) {
        return;
    }

    const loader = availableLoader;

    function load(url: string | undefined, done: () => void) {
        var script = document.createElement('script');
        var settled = false;

        function finish(failed: boolean) {
            if (settled) {
                return;
            }

            settled = true;

            if (failed) {
                console.error('A theme asset could not be loaded.', url);
            }

            done();
        }

        script.onload = function () {
            finish(false);
        };
        script.onerror = function () {
            finish(true);
        };

        try {
            if (!url) {
                return finish(true);
            }

            script.src = url;
            document.head.appendChild(script);
        } catch (error) {
            finish(true);
        }
    }

    const candidates: [string, string][] = [
        [
            'media',
            ".lightbox,[rel=single-photo],.gallery [rel=gallery],.lightbox-video,a.product-gallery,iframe[src*='youtube'],iframe[src*='vimeo'],object,embed"
        ],
        ['layout', '.sticky-sidebar,.onepage-nav,.row-portfolio,.blog-masonry,.row-shop-masonry'],
        ['effects', '.wow,.progress-bar,.counter-timer,.chart,.parallax,[data-jarallax-video],[data-jarallax-element]'],
        ['widgets', '.map,.module-slides,.flexslider,.rotate,.ripples,#particles-js,#particles-snow-js']
    ];
    const features = candidates.filter((feature) => document.querySelector(feature[1]));
    var initialized = false;

    function initialize() {
        if (initialized) {
            return;
        }

        initialized = true;
        load(loader.dataset.customSrc, function () {});
    }

    var remaining = features.length;

    if (!remaining) {
        initialize();
    }

    features.forEach(function (feature) {
        load(loader.dataset[feature[0] + 'Src'], function () {
            if (!--remaining) {
                initialize();
            }
        });
    });
})();
